// German translations
export const de = {
  // App
  appName: 'CarTrip',
  
  // Auth
  signIn: 'Anmelden',
  signUp: 'Registrieren',
  signOut: 'Abmelden',
  email: 'E-Mail',
  emailAddress: 'E-Mail-Adresse',
  password: 'Passwort',
  fullName: 'Vollständiger Name',
  enterEmail: 'E-Mail eingeben',
  enterPassword: 'Passwort eingeben',
  enterFullName: 'Vollständigen Namen eingeben',
  authentication: 'Authentifizierung',
  planTripsEase: 'Planen Sie Ihre Reisen mit Leichtigkeit',
  loginRequired: 'Anmeldung erforderlich',
  loginRequiredDescription: 'Bitte melden Sie sich an, um Reisestopps zu erstellen und zu verwalten',
  
  // Navigation
  home: 'Startseite',
  profile: 'Profil',
  settings: 'Einstellungen',
  menu: 'Menü',
  analytics: 'Analytik',
  
  // Trips
  myTrips: 'Meine Reisen',
  newTrip: 'Neue Reise',
  selectTrip: 'Reise auswählen',
  tripName: 'Reisename',
  tripNamePlaceholder: 'z.B. Sommerurlaub 2025',
  createTrip: 'Reise erstellen',
  createFirstTrip: 'Erstellen Sie Ihre erste Reise!',
  deleteTrip: 'Reise löschen',
  noTrips: 'Noch keine Reisen. Erstellen Sie Ihre erste Reise!',
  stops: 'Stopps',
  stopsTitle: 'Stopps',
  stopsCount: 'Anzahl der Stopps',
  tripHistory: 'Reiseverlauf',
  searchTrips: 'Reisen suchen...',
  
  // Stops
  addStop: 'Stopp hinzufügen',
  editStop: 'Stopp bearbeiten',
  deleteStop: 'Stopp löschen',
  noStops: 'Noch keine Stopps',
  address: 'Adresse',
  stopType: 'Stopp-Typ',
  stopName: 'Stopp-Name',
  notes: 'Notizen',
  
  // Stop types
  city: 'Stadt',
  gasStation: 'Tankstelle',
  evCharging: 'EV-Ladestation',
  restaurant: 'Restaurant',
  hotel: 'Hotel',
  attraction: 'Sehenswürdigkeit',
  parking: 'Parkplatz',
  rest: 'Rastplatz',
  other: 'Sonstiges',
  
  // Map
  map: 'Karte',
  findNearbyPOI: 'POI in der Nähe finden',
  customStop: 'Benutzerdefinierter Stopp',
  
  // Timeline
  timeline: 'Zeitachse',
  
  // Calculator
  tripCalculator: 'Reiserechner',
  totalDistance: 'Gesamtstrecke',
  totalDuration: 'Gesamtdauer',
  totalCost: 'Gesamtkosten',
  fuelCost: 'Kraftstoffkosten',
  
  // Settings
  language: 'Sprache',
  languageNative: 'Sprache',
  theme: 'Design',
  appearance: 'Erscheinungsbild',
  themeLight: 'Hell',
  themeDark: 'Dunkel',
  themeAuto: 'Automatisch',
  mapLabels: 'Kartenbeschriftungen',
  cityAndStreetNames: 'Stadt- und Straßennamen',
  localLanguage: 'Lokale Sprache',
  englishLanguage: 'Englisch',
  
  // Vehicles
  vehicles: 'Fahrzeuge',
  myVehicles: 'Meine Fahrzeuge',
  addVehicle: 'Fahrzeug hinzufügen',
  noVehicles: 'Noch keine Fahrzeuge',
  
  // Common
  cancel: 'Abbrechen',
  delete: 'Löschen',
  close: 'Schließen',
  save: 'Speichern',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  search: 'Suchen',
  loading: 'Lädt...',
  error: 'Fehler',
  success: 'Erfolg',
  
  // Units & Formats
  km: 'km',
  mi: 'mi',
  kmh: 'km/h',
  mph: 'mph',
  liters: 'Liter',
  gallons: 'Gallonen',
  currency: 'Währung',
}
